import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { type KeycloakProfile } from 'keycloak-js'
import type Keycloak from 'keycloak-js'

/**
 * The queryKey we are using to store our Keycloak profile data in React Query memory.
 */
export const profileQueryKey = 'keycloak-profile'

export const useExecuteTanStackQuery = (
  keycloakInstance: Keycloak | undefined,
  enabled = true
): UseQueryResult<KeycloakProfile> => {
  const emptyPromise = () =>
    new Promise<KeycloakProfile>((resolve) => {
      resolve({})
    })

  return useQuery({
    /**
     * Enable the query or not
     */
    enabled,

    /**
     * We are using Reac Query to execute the loadUserProfile available in our Keycloak Instance
     */
    queryFn: keycloakInstance?.loadUserProfile ?? emptyPromise,

    /**
     * Making sure our cache key is unique to not interfere with application keys
     */
    queryKey: [profileQueryKey],

    /**
     * There is no need to refetch this data when user comes back
     * since our authenticated guard in applications makes sure the user goes to login when not authenticated
     */
    refetchOnMount: false,

    /**
     * Keep this data in RQ memory
     */
    gcTime: Infinity,
  })
}
